var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsmenu = function SvgDotsmenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.502 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M12.499 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.497 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
  })));
};
export { SvgDotsmenu as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZThiN2QxN2MzNGI2MjQ1NTZhNTkxZGExNWIzN2M3ODcuc3ZnIjs=";